import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { inquiryService, Inquiry } from 'services/inquiryService';
import {
  Body,
  Header,
  BackButton,
  InquiryList as InquiryListContainer,
  InquiryItem,
  InquiryHeader,
  InquiryTitle,
  InquiryStatus,
  InquiryContent,
  InquiryDate,
  CreateButton,
  EmptyMessage,
  NoticeSection,
  NoticeTitle,
  NoticeItem,
  NoticeLink
} from './InquiryList.styles';

function InquiryList() {
  const navigate = useNavigate();
  const [inquiries, setInquiries] = useState<Inquiry[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const data = await inquiryService.getMyInquiries();
        setInquiries(data);
      } catch (error) {
        console.error('Error fetching inquiries:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInquiries();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleInquiryClick = (id: number) => {
    navigate(`/inquiry/${id}`);
  };

  const handleCreateClick = () => {
    navigate('/inquiry/create');
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}.${month}.${day}`;
  };

  if (isLoading) {
    return (
      <Body>
        <Header>
          <BackButton onClick={handleGoBack}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </BackButton>
          문의하기
        </Header>
        <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
      </Body>
    );
  }

  return (
    <Body>
      <Header>
        <BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </BackButton>
        문의하기
      </Header>

      {inquiries.length > 0 ? (
        <InquiryListContainer>
          {inquiries.map((inquiry) => (
            <InquiryItem key={inquiry.id} onClick={() => handleInquiryClick(inquiry.id)}>
              <InquiryHeader>
                <InquiryTitle>{inquiry.title}</InquiryTitle>
                <InquiryStatus answered={inquiry.status === 'ANSWERED'}>
                  {inquiry.status === 'ANSWERED' ? '답변완료' : '답변대기'}
                </InquiryStatus>
              </InquiryHeader>
              <InquiryContent>{inquiry.content}</InquiryContent>
              <InquiryDate>{formatDate(inquiry.createdAt)}</InquiryDate>
            </InquiryItem>
          ))}
        </InquiryListContainer>
      ) : (
        <EmptyMessage>작성된 문의가 없습니다.</EmptyMessage>
      )}

      <NoticeSection>
        <NoticeTitle>유의사항</NoticeTitle>
        <NoticeItem>
          상담에 필요한 정보 외 개인정보를 포함하지 않도록 주의해주세요.
        </NoticeItem>
        <NoticeItem>
          <NoticeLink onClick={() => navigate('/faq')}>자주묻는질문</NoticeLink>을 확인하면 답변을 빨리 받을 수 있어요.
        </NoticeItem>
        <NoticeItem>
          접수는 24시간 가능하지만, 답변은 9시~18시에 순차적으로 받을 수 있어요.
        </NoticeItem>
      </NoticeSection>

      <CreateButton onClick={handleCreateClick}>
        문의하기
      </CreateButton>
    </Body>
  );
}

export default InquiryList;
